module.exports = "img{\r\n    width: 200px;\r\n    height: 150px;\r\n}\r\n\r\n.imgdesc{\r\n    background: #f4f4f4;\r\n\tpadding: 20px;\r\n    margin-top: 30px;\r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/materials/materials.component.css
// module id = ./src/app/materials/materials.component.css
// module chunks = main